import { Progress, Typography } from 'antd'
import cls from 'classnames'
import { isString } from 'lodash'
import React from 'react'

import s from '../onboarding.module.less'

export const OnboardingPageLayout: React.FC<{
  left: React.ReactNode
  footer: React.ReactNode
  percent: number
  header?: React.ReactNode | string
  subHeader?: React.ReactNode | string
  subHeaderAction?: React.ReactNode
  right?: React.ReactNode
}> = ({ left, footer, percent, header, subHeader, subHeaderAction, right }) => {
  return (
    <div className={s.pages}>
      <Progress
        type='line'
        strokeColor={{
          '0%': '#108ee9',
          '100%': '#87d068',
        }}
        percent={Math.round((percent / 7) * 100)}
        format={() => `${percent}/7`}
      />
      {header && (
        <Typography.Title level={1} className={s.header}>
          {header}
        </Typography.Title>
      )}
      {subHeader && (
        <div
          className={s.subHeader}
          style={{ justifyContent: subHeader && subHeaderAction ? 'space-between' : undefined }}
        >
          {isString(subHeader) ? (
            <Typography.Title style={{ marginTop: 0, color: '#48bbb5' }} level={5}>
              {subHeader}
            </Typography.Title>
          ) : (
            subHeader
          )}
          {subHeaderAction}
        </div>
      )}
      <div className={s.page}>
        <div className={cls(s.left)}>{left}</div>
        {right && <div className={s.right}>{right}</div>}
      </div>
      {footer && <div className={s.footer}>{footer}</div>}
    </div>
  )
}
